import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { TranscoderProfile } from '@vxui/common';
import { SimplifiedTemplate } from './profilesTable.types';

export const filterByTemplate = (profile: TranscoderProfile, templateId: string) =>
  templateId === '' ? true : profile.templates?.find(temp => temp.id === templateId);

const deduplicate = (templates: SimplifiedTemplate[]) =>
  templates.filter((v, i, a) => a.findIndex(item => item.id === v.id) === i);

export const useTemplateFilter = (data: TranscoderProfile[]) => {
  const [current, setCurrent] = useState('');

  const templates = useMemo(
    () =>
      deduplicate(
        data
          .flatMap(profile => profile.templates || [])
          .map(template => ({
            name: template.name,
            id: template.id,
          })),
      ),
    [data],
  );

  return [[current, setCurrent], templates] as [[string, Dispatch<SetStateAction<string>>], SimplifiedTemplate[]];
};
